import { configCat } from '@/featureFlags/ConfigCat';

export const useFlags = configCat.featureFlagManagement.useFeatureFlags;
